import { personelMaliKarti } from "./finans.js";
import { yapabilir } from "../domain/auth.js";
import { personelBelgeKarti } from "../components/documents.js";
import { alerjiler, hayatiRisk } from "../domain/students.js";
import { ATT, card, classChip, emptyNote, sectionTitle } from "../components/ui.js";
import { B, cls, staffOf } from "../domain/context.js";
import { age, esc, fmtDate, money } from "../lib/fmt.js";
import { avatar } from "../lib/avatar.js";
import { photoBlock, photoControls } from "../lib/photo.js";
import { state } from "../state.js";
import { viewPersonel } from "./personel.js";

// ---------- PERSONEL DETAYI ----------
export function viewPersonelDetay() {
  const t = B();
  const p = staffOf(state.staffId);
  if (!p) return viewPersonel();

  const c = p.classId ? cls(p.classId) : null;
  const kids = c ? t.students.filter(s => s.classId === c.id) : [];
  const kidem = (() => {
    const b = new Date(p.startDate), now = new Date();
    const ay = (now.getFullYear() - b.getFullYear()) * 12 + (now.getMonth() - b.getMonth());
    const y = Math.floor(ay / 12), m = ay % 12;
    return y ? `${y} yıl${m ? ` ${m} ay` : ""}` : `${m} ay`;
  })();

  // Role göre değişen bölüm
  let rolBolumu = "";

  if (c) {
    const gelen = kids.filter(s => t.attendance[s.id]?.status === "geldi");
    rolBolumu = card(`
      <div class="p-5">
        ${sectionTitle("Sorumlu Olduğu Sınıf", `<a href="#/siniflar/${c.id}" class="text-xs font-semibold text-teal hover:underline">Sınıf detayı →</a>`)}
        <div class="flex items-center gap-3 rounded-xl p-3 mb-4" style="background:${c.color}1A">
          <span class="w-3 h-3 rounded-full" style="background:${c.color}"></span>
          <span class="flex-1">
            <span class="block font-semibold">${esc(c.name)} · ${c.age}</span>
            <span class="block text-[11px] text-inksoft">${esc(c.room)} · ${esc(c.ratio)}</span>
          </span>
          <span class="text-sm font-bold" style="color:${c.color}">${gelen.length}/${kids.length} bugün geldi</span>
        </div>
        <div class="grid gap-2 sm:grid-cols-2">
          ${kids.map(s => {
            const a = t.attendance[s.id];
            return `<button data-student="${s.id}" class="min-w-0 flex items-center gap-3 rounded-xl border border-line bg-paper/50 hover:bg-paper px-3 py-2 text-left">
              ${avatar(s, "w-8 h-8")}
              <span class="min-w-0 flex-1">
                <span class="block text-sm font-semibold truncate">${esc(s.name)}</span>
                <span class="block text-[11px] text-inksoft">${age(s.birthDate)}</span>
              </span>
              <span class="w-2 h-2 rounded-full ${ATT[a.status].dot}"></span>
            </button>`;
          }).join("") || emptyNote("Sınıfta kayıtlı öğrenci yok.")}
        </div>
      </div>`);
  } else if (/aşçı|mutfak/i.test(p.role)) {
    const alerjik = t.students.filter(s => s.allergies.length)
      .sort((a, b) => Number(hayatiRisk(b)) - Number(hayatiRisk(a)));
    const gunler = Object.keys(t.menu);
    const bugun = new Date().toLocaleDateString("tr-TR", { weekday: "long" });
    rolBolumu = `
      ${card(`
        <div class="p-5">
          ${sectionTitle("Mutfak Panosu — Alerjen Listesi", `<span class="text-[11px] rounded-full bg-coral-soft text-coral font-bold px-2 py-0.5">${alerjik.length} çocuk</span>`)}
          <div class="grid gap-2 sm:grid-cols-2">
            ${alerjik.map(s => `
              <button data-student="${s.id}" class="min-w-0 flex items-center gap-3 rounded-xl bg-coral-soft/60 hover:bg-coral-soft px-3 py-2 text-left">
                ${avatar(s, "w-8 h-8")}
                <span class="min-w-0 flex-1">
                  <span class="block text-sm font-semibold truncate">${esc(s.name)}</span>
                  <span class="block text-[11px] text-coral font-semibold">${alerjiler(s).map(a => esc(a.name) + (a.severity === "anafilaksi" ? " ⚠ ANAFİLAKSİ" : a.severity === "agir" ? " (ağır)" : "")).join(", ")}</span>
                </span>
                ${classChip(s.classId)}
              </button>`).join("") || emptyNote("Alerjen kaydı yok.")}
          </div>
        </div>`)}
      ${card(`
        <div class="p-5">
          ${sectionTitle("Bugünün Menüsü", `<a href="#/menu" class="text-xs font-semibold text-teal hover:underline">Haftalık menü →</a>`)}
          ${gunler.includes(bugun) ? `
            <div class="space-y-3 text-sm">
              <div><div class="text-[11px] font-bold text-inksoft mb-0.5">🥐 KAHVALTI</div>${esc(t.menu[bugun].kahvalti)}</div>
              <div><div class="text-[11px] font-bold text-inksoft mb-0.5">🍲 ÖĞLE</div>${esc(t.menu[bugun].ogle)}</div>
              <div><div class="text-[11px] font-bold text-inksoft mb-0.5">🍎 İKİNDİ</div>${esc(t.menu[bugun].ikindi)}</div>
            </div>` : emptyNote("Bugün hafta sonu — menü planlanmamış.")}
        </div>`)}`;
  } else if (/servis/i.test(p.role)) {
    const servisli = t.students.filter(s => s.service);
    rolBolumu = card(`
      <div class="p-5">
        ${sectionTitle("Servis Listesi", `<span class="text-[11px] rounded-full bg-sky-soft text-sky font-bold px-2 py-0.5">${servisli.length} çocuk</span>`)}
        <div class="grid gap-2 sm:grid-cols-2">
          ${servisli.map(s => {
            const a = t.attendance[s.id];
            return `<button data-student="${s.id}" class="min-w-0 flex items-center gap-3 rounded-xl border border-line bg-paper/50 hover:bg-paper px-3 py-2 text-left">
              ${avatar(s, "w-8 h-8")}
              <span class="min-w-0 flex-1">
                <span class="block text-sm font-semibold truncate">${esc(s.name)}</span>
                <span class="block text-[11px] text-inksoft truncate">${esc(s.parent)} · ${esc(s.parentPhone)}</span>
              </span>
              <span class="text-[10px] font-bold rounded-full px-2 py-0.5 ${ATT[a.status].chip}">${ATT[a.status].label}</span>
            </button>`;
          }).join("") || emptyNote("Servis kullanan öğrenci yok.")}
        </div>
        <p class="text-[11px] text-inksoft mt-3">Servis ücreti ${money(t.serviceFee)} / ay · aylık servis geliri ${money(servisli.length * t.serviceFee)}</p>
      </div>`);
  } else if (/psikolog/i.test(p.role)) {
    const takip = t.students.filter(s =>
      /uyum/i.test(s.note) ||
      t.dailyReports.some(r => r.studentId === s.id && /tedirgin|yorgun/i.test(r.mood)));
    rolBolumu = card(`
      <div class="p-5">
        ${sectionTitle("Takip Önerilen Çocuklar", `<span class="text-[11px] text-inksoft">uyum süreci & günlük rapor işaretleri</span>`)}
        <div class="space-y-2">
          ${takip.map(s => {
            const rep = t.dailyReports.find(r => r.studentId === s.id);
            return `<button data-student="${s.id}" class="w-full flex items-center gap-3 rounded-xl border border-line px-3 py-2.5 text-left hover:bg-paper/60">
              ${avatar(s, "w-9 h-9")}
              <span class="min-w-0 flex-1">
                <span class="block text-sm font-semibold truncate">${esc(s.name)}</span>
                <span class="block text-[11px] text-inksoft truncate">${/uyum/i.test(s.note) ? "Uyum sürecinde" : ""}${/uyum/i.test(s.note) && rep ? " · " : ""}${rep ? `Ruh hali: ${esc(rep.mood)}` : ""}</span>
              </span>
              ${classChip(s.classId)}
            </button>`;
          }).join("") || emptyNote("Şu an takip önerilen çocuk yok 🎉")}
        </div>
      </div>`);
  } else {
    // Sınıfa veya özel bir göreve bağlı olmayan roller (müdür, temizlik vb.)
    const gelen = Object.values(t.attendance).filter(a => a.status === "geldi").length;
    rolBolumu = card(`
      <div class="p-5">
        ${sectionTitle("Şube Özeti", `<span class="text-[11px] text-inksoft">${esc(p.role)} için sınıf ataması yok</span>`)}
        <div class="grid gap-2 sm:grid-cols-2">
          ${[
            ["Öğrenci", `${t.students.length}`, `bugün ${gelen} çocuk okulda`],
            ["Sınıf", `${t.classes.length}`, t.classes.map(c => c.name).join(", ")],
            ["Personel", `${t.staff.length}`, `${t.staff.filter(x => x.status === "aktif").length} aktif`],
            ["Aday", `${t.applications.filter(a => !["kayit", "kaybedildi"].includes(a.stage)).length}`, "hunide aktif başvuru"],
          ].map(([b, deger, alt]) => `
            <div class="min-w-0 rounded-xl bg-paper p-3">
              <div class="text-[11px] font-bold text-inksoft uppercase">${b}</div>
              <div class="font-display font-extrabold text-xl mt-0.5">${deger}</div>
              <div class="text-[11px] text-inksoft truncate">${esc(alt)}</div>
            </div>`).join("")}
        </div>
      </div>`);
  }

  return `
  <a href="#/personel" class="inline-flex items-center gap-1.5 text-sm font-semibold text-inksoft hover:text-ink mb-3">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
    Tüm personel
  </a>

  ${card(`
    <div class="h-2.5 rounded-t-2xl bg-grape"></div>
    <div class="p-5 flex flex-wrap items-start gap-5">
      ${photoBlock(p, "staff", "#8E7CC3", "w-20 h-20")}
      <div class="min-w-0 flex-1">
        <div class="flex items-center gap-2 flex-wrap">
          <h2 class="font-display font-extrabold text-2xl">${esc(p.name)}</h2>
          ${p.status === "aktif"
            ? `<span class="text-[11px] font-bold rounded-full bg-teal-soft text-teal px-2.5 py-1">Aktif</span>`
            : `<span class="text-[11px] font-bold rounded-full bg-sun-soft text-[#B07E14] px-2.5 py-1">İzinli</span>`}
        </div>
        <div class="text-sm text-inksoft mt-0.5">${esc(p.role)}${c ? " · " : ""}${c ? esc(c.name) : ""}</div>
        ${p.leaveNote ? `<div class="mt-3 rounded-xl bg-sun-soft px-3 py-2 text-sm">🌴 ${esc(p.leaveNote)}</div>` : ""}
        ${photoControls(p, "staff")}
      </div>
      <div class="rounded-xl bg-paper px-4 py-2 text-center">
        <div class="font-display font-extrabold text-xl">${kidem}</div>
        <div class="text-[10px] font-bold uppercase text-inksoft">Kıdem</div>
      </div>
    </div>`, "overflow-hidden mb-4")}

  <div class="grid gap-4 lg:grid-cols-3">
    <div class="min-w-0 lg:col-span-2 space-y-4">${rolBolumu}</div>

    <div class="min-w-0 space-y-4">
      ${card(`
        <div class="p-5">
          ${sectionTitle("İletişim & Mesai")}
          <dl class="space-y-3 text-sm">
            <div><dt class="text-[11px] font-bold text-inksoft uppercase">Telefon</dt><dd class="font-semibold">${esc(p.phone)}</dd></div>
            <div><dt class="text-[11px] font-bold text-inksoft uppercase">E-posta</dt><dd class="break-all">${esc(p.email)}</dd></div>
            <div><dt class="text-[11px] font-bold text-inksoft uppercase">Mesai</dt><dd>${esc(p.shift)}</dd></div>
            <div><dt class="text-[11px] font-bold text-inksoft uppercase">İşe Başlama</dt><dd>${fmtDate(p.startDate)} ${new Date(p.startDate).getFullYear()}</dd></div>
          </dl>
        </div>`)}

      ${card(`
        <div class="p-5">
          ${sectionTitle("Eğitim")}
          <div class="text-sm font-semibold">${esc(p.education)}</div>
        </div>`)}

      ${personelBelgeKarti(p, t.id)}

      ${yapabilir("maasGor") ? personelMaliKarti(p, t.id) : ""}
    </div>
  </div>`;
}

